export type AccessTokenGetter = () => Promise<string>

let accessTokenGetter: AccessTokenGetter | null = null

export const setAccessTokenGetter = (getter: AccessTokenGetter | null) => {
  accessTokenGetter = getter
}

export const getAccessTokenFromProvider = async (): Promise<string | null> => {
  if (!accessTokenGetter) return null
  return await accessTokenGetter()
}
